var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"create-page"}},[_c('UpdateCreateExpense',{on:{"expense-received":function($event){return _vm.addExpense($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }